import { render, staticRenderFns } from "./crossDockPerformance.vue?vue&type=template&id=c589e1ea&scoped=true"
import script from "./crossDockPerformance.vue?vue&type=script&lang=js"
export * from "./crossDockPerformance.vue?vue&type=script&lang=js"
import style0 from "./crossDockPerformance.vue?vue&type=style&index=0&id=c589e1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c589e1ea",
  null
  
)

export default component.exports